import * as React from 'react';
import { Button } from 'telstra-ui/components/button/Button';
import { nullEnquiries } from '@images';
import { navigateType } from '@utils/withRouterWrapper';
interface IEmptyEnquiriesProps {
    className?: string;
    onTryAgain?: () => void
    category?: string
    cidn?: string
    navigate: navigateType
}

export const EmptyEnquiries: React.FunctionComponent<IEmptyEnquiriesProps> = (props) => {
    const BILLING_ENQUIRIES = 'Have a question about an order?';

    const QUERY_INT_TEXT = 'We can help.';
    const RAISE_AN_ENQUIRY = 'Submit an enquiry';
    const raiseEnquiry = () => {
        if (props.category === 'Order_Enquiry') {
            const urlPath = '/app/customer-support/new-enquiry-form'
            let detailsURL =
                `${urlPath}?category=Your orders&selectedCidn=${props.cidn}&defaultCidn=${props.cidn}`;
            detailsURL += `&subCategory=General enquiry`
            props.navigate(detailsURL);
        }
    }
    return (
        <div className="tc-st tc-ccd-error">
            <div id="tc-st-page-load-center">
                <div className="tc-st-page-load-indicator-container">
                    <div>
                        <div className="tc-st-page-load-indicator">
                            {/* <SvgIcon name="icon-system-error-solid" className="comments-icon-size" /> */}
                            <img className="null-enquiry-size" src={nullEnquiries} />
                        </div>
                        <div className="tc-enquiry-header text-bold enquiry-margin-10">{BILLING_ENQUIRIES}</div>
                        <div className="tc-enquiry-query text-regular enquiry-margin-10">{QUERY_INT_TEXT}</div>
                        <div className="tc-raise-enquiry-btn enquiry-margin-30">
                            <Button type="button" label={RAISE_AN_ENQUIRY} className="button-pads"
                                variant="super" size="xsmall" onClick={raiseEnquiry} />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
};
